<template>
    <div class="container">
        <vue-headful title="ABL Groupe | Fedriga" />
        <h2>Fedriga</h2>
        <section class="society--process">
            <div class="society--content">
                <div class="society--process--picture col-xs-12 col-md-5"><img :src="require('../../assets/images/fedriga.png')"/></div>
                <div class="society--process--description flex-end col-xs-12 col-md-5">
                    <div class="col-xs-12">
                        <h3>Tous inox, duplex, superduplex, alliages base nickel</h3>
                        <section class="forge--box">
                            <div class="forge--items">
                                <div class="forge--item">
                                    <p>Arbres<span>/Rounds</span></p>
                                    <div class="forge--item-text">
                                        <p>ø max : 700mm</p>
                                        <p>L max : 6000mm</p>
                                        <p>Poids max / weight : 20 t</p>
                                    </div>
                                </div>
                                <div class="forge--item">
                                    <p>Disques<span>/Discs</span></p>
                                    <div class="forge--item-text">
                                        <p>ø max : 1950mm</p>
                                        <p>Poids max / weight : 9 t</p>
                                    </div>
                                </div>
                                <div class="forge--item">
                                    <p>Viroles<span>/Bushes</span></p>
                                    <div class="forge--item-text">
                                        <p>øe max : 1950mm</p>
                                        <p>øi max : 1850mm</p>
                                        <p>L max : 1500mm</p>
                                        <p>Poids max / weight : 15 t</p>
                                    </div>
                                </div>
                                <div class="forge--item">
                                    <p>Tubes forgés<span>/Tubings</span></p>
                                    <div class="forge--item-text">
                                        <p>øe max : 1500mm</p>
                                        <p>øi max : 1400mm</p>
                                        <p>L max : 6000mm</p>
                                        <p>Poids max / weight : 15 t</p>
                                    </div>
                                </div>
                                <div class="forge--item">
                                    <p>Cays<span>/Hubs</span></p>
                                    <div class="forge--item-text">
                                        <p>ø max : 1700mm</p>
                                        <p>Poids max / weight : 8/10 t</p>
                                    </div>
                                </div>
                            </div>
                        </section>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "FedrigaFreeForge"
    }
</script>

<style scoped>
    .forge--box .forge--items {
        justify-content: space-between;
        padding: 0 0 40px 0
    }
</style>